import { FitnessGoals } from "@/constants/fitnessGoal";
import { FitnessLevels } from "@/constants/fitnessLevels";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { Answers } from "@/utils/AnswersProvider";

/** Fake answers for screens that depend on previous data (e.g. BMI). Injected once when entering E2E test funnel. */
export const E2E_TEST_FUNNEL_FAKE_ANSWERS: Answers = {
    [QUESTIONS_IDS.PRIMARY_GOAL]: FitnessGoals.LoseWeight,
    [QUESTIONS_IDS.FITNESS_LEVEL]: FitnessLevels.Beginner,
    [QUESTIONS_IDS.HEIGHT]: 170,
    [QUESTIONS_IDS.CURRENT_WEIGHT]: 70,
    [QUESTIONS_IDS.TARGET_WEIGHT]: 65,
};
